// extracted by mini-css-extract-plugin
export default {"box":"favorite_box__TxWaX","favorite":"favorite_favorite__1RUE8","header":"favorite_header__GYR5l"};